import { useQuery } from '@apollo/react-hooks';
import { SHORT_STRINGS_QUERY } from './queries';

/* eslint-disable @typescript-eslint/no-explicit-any */
function toItems(data) {
  var _data$simpleStringCol;

  var sets = data === null || data === void 0 ? void 0 : (_data$simpleStringCol = data.simpleStringCollection) === null || _data$simpleStringCol === void 0 ? void 0 : _data$simpleStringCol.items;

  if (!sets || sets.length === 0) {
    return [];
  }

  var items = sets.reduce(function (r, item) {
    if (item && item.key && item.entryTitle) {
      r.push({
        key: item.entryTitle,
        text: item.key
      });
    }

    return r;
  }, []);
  return items;
}

var useResourceSet = function useResourceSet(resourceSetId) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

  var _useQuery = useQuery(SHORT_STRINGS_QUERY, {
    variables: {
      teamLabel: 'UIAM',
      locale: locale
    }
  }),
      loading = _useQuery.loading,
      error = _useQuery.error,
      data = _useQuery.data;

  var items = !loading && !error && data ? toItems(data) : [];
  return {
    loading: loading,
    error: error,
    items: items
  };
};

export default useResourceSet;